import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Layout, Card, Col, Row, Spin } from 'antd'
import Skeleton from 'react-loading-skeleton'
import IntlMessages from '../../util/IntlMessages'
import HomeCards from '../../components/HomeCards'
import DashboardReporting from '../../components/Dashboard/DashboardReporting'
import {
  isEmptyObject,
  checkRightspermissions
} from '../../appRedux/actions/GlobalMethods'
import { HOME } from '../../constants/Pages'
import { setCommonConfigs } from '../../appRedux/actions/CommonData'
import { loadFetchProducts } from '../../appRedux/actions'
import { checkIsWeb, postDataToApp } from '../../appRedux/actions/MobAppFn'
import { PostAppTypes } from '../../constants/MobAppConstants'

const Dashboard = () => {
  const dispatch = useDispatch()

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const products = useSelector(({ Products }) => Products.products)
  const loading = useSelector(({ Products }) => Products.loading)
  const error = useSelector(({ Products }) => Products.error)

  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [loader, setLoader] = useState(true)

  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getIsDashboardReportAllowed, setIsDashboardReportAllowed] =
    useState(false)

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (!checkIsWeb().exist) {
        postDataToApp(PostAppTypes.PAGE_HEADER, 'app.reporting.dashboard')
      }

      const commonData = getReduxCommonSetting
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        setLoader(false)
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])
  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
    if (rpData.dashboardReportAllow) {
      setIsDashboardReportAllowed(true)
    } else {
      setIsDashboardReportAllowed(false)
    }
  }
  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
    setIsDashboardReportAllowed(false)
  }

  return (
    <Spin tip={'Loading'} spinning={loader} size='large'>
      {getIsDashboardReportAllowed ? <DashboardReporting /> : <HomeCards />}
    </Spin>
  )
}
export default Dashboard
